import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "关闭弹窗",
  "use": "关闭弹窗-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"关闭弹窗\"><path d=\"M512 0c282.7776 0 512 229.2224 512 512s-229.2224 512-512 512S0 794.7776 0 512 229.2224 0 512 0z m230.912 243.0464L514.2528 459.264 285.5424 243.0464l-46.5408 49.152L464.9472 505.856l-225.9456 213.6064 46.5408 49.152 228.6592-216.2176 228.7616 216.2688 46.4896-49.2032-225.9968-213.6576 225.9968-213.5552-46.4896-49.2032z\" p-id=\"5264\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol